import * as ko from "knockout";
import {global} from "../../appContext";
import PromiseRequest from "../../req/PromiseRequest";
import {IMessageData, IRouteDefinitionParams} from "../../index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {createErrorMessage} from "../../util/misc";
import {nsRoute} from "../../util/route";
import {REQUEST_MESSAGE} from "../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import testHtml from './test.html?raw';

export let template: string = testHtml;


export class viewModel extends ParsedRouteDataDecorator {
    isWaiting: KnockoutObservable<boolean | null> = ko.observable(null);
    isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private reqTest: PromiseRequest = global.getPromiseRequest("testimportfile");
    data!: string;

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.initRequest();
    }

    private initRequest() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.isWaiting(true);
        this.reqTest
            .request({id: global.getRouteId()})
            .then((data: any[]) => {
                this.data = data[0];
                this.messageData(null);
                this.isWaiting(false);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.isWaiting(false);
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    override dispose() {
        this.kosub.unsuscribeAll();
        this.reqTest.abort();
    }

}
